module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-small-thumbnails-rect-250x125-432e06b976daba39a3b0786b806d5afd.jpg";